module.exports = "/images/protected-3-year-seller.png?09370f2f8ed09a9695efa3c5eee56add";